module.exports = __webpack_public_path__ + "static/fipclemonbrave4-9ebdb38ef933214b59cbdea87b0f4c5f.jpeg";